import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';


@Directive({ selector: 'textarea[redCaretPosition]' })
export class CaretPositionDirective {

  private readonly element: HTMLTextAreaElement;

  private caretPosition: number;

  @Output() redCaretPosition: EventEmitter<number>;

  @HostListener('keydown')
  public keydownListener() { this.updateCaretPosition(); }

  @HostListener('mouseup')
  public mouseupListener() { this.updateCaretPosition(); }

  constructor(private elementRef: ElementRef) {
    this.element          = this.elementRef.nativeElement;
    this.redCaretPosition = new EventEmitter<number>();
    this.caretPosition    = 0;
  }

  private updateCaretPosition() {
    this.caretPosition  = this.element && this.element.selectionStart || 0;
    this.redCaretPosition.emit(this.caretPosition);
  }
}
